<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="User Management">
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="items.users"
                rowKey="hash"
                :pagination="false"
                :loading="loading"
                bordered>

                <a-table-column key="photo" title="Foto" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <div style="text-align: center">
                            <img :src="record.photo" v-if="record.photo != null" height="50" />
                            <a-avatar class="avatar" size="large" shape="circle" v-else>{{ initial(record.name) }}</a-avatar>
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="name" title="Nama" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ record.name }}
                    </template>
                </a-table-column>

                <a-table-column key="gender" title="Gender" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ gender(record.gender) }}
                    </template>
                </a-table-column>

                <a-table-column key="email" title="Email" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ record.email }}
                    </template>
                </a-table-column>

                <a-table-column key="training" title="Pelatihan" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <template v-for="(item, index) in record.members">
                            <a-icon type="property-safety" :key="item.training.hash" /> {{ item.training.title }} <br :key="index" />
                        </template>
                    </template>
                </a-table-column>

                <a-table-column key="action" title="Action" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <a-tooltip title="Detail">
                            <a-button size="small" icon="eye" :href="routeUri('admin.setting.user.management.detail') + '?user=' + record.hash" />
                        </a-tooltip>
                    </template>
                </a-table-column>

            </a-table>
        </a-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            items: {},
            loading: false,
            processing: false,
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true;

            this.$http
                .get(this.routeUri("api.users"))
                .then(response => this.items = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        gender(gender){
            switch(gender){
                case "male":
                    return "Laki-laki"
                case "female":
                    return "Perempuan"
                default:
                    return ""
            }
        },
    }
}
</script>